import ProductsList from "../views/ProductsList"
import ProductDetail from "../views/ProductDetail"
import ProductCreate from "../views/ProductCreate"
import ProductBenefits from "../views/ProductBenefits"
import ProductUnderwriting from "../views/ProductUnderwriting"
import ProductPricing from "../views/ProductPricing"

export default [
	{
		path: "/:tenantId/products",
		component: ProductsList,
		name: "ProductsList",
		meta: { featureId: "products" }
	},
	{
		path: "/:tenantId/products/detail/:plan/:type/:version?",
		component: ProductDetail,
		name: "ProductDetail",
		meta: { featureId: "products" },
		props: true
	},
	{
		path: "/:tenantId/products/create",
		component: ProductCreate,
		name: "ProductCreate",
		meta: { featureId: "products" },
		props: true
	},
	{
		path: "/:tenantId/products/detail/benefits/:plan/:type/:version?",
		component: ProductBenefits,
		name: "ProductBenefits",
		meta: { featureId: "products" },
		props: true
	},
	{
		path: "/:tenantId/products/detail/underwriting/:plan/:type/:version?",
		component: ProductUnderwriting,
		name: "ProductUnderwriting",
		meta: { featureId: "products" },
		props: true
	},
	{
		path: "/:tenantId/products/detail/pricing/:plan/:type/:version?",
		component: ProductPricing,
		name: "ProductPricing",
		meta: { featureId: "products" },
		props: true
	}
]
